import React from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { getCourseEditorPathByType } from 'helpers/getLessonPathByCourseType';

import CoursePreviewLayout from './CoursePreviewLayout';

const CoursePreviewLayoutContainer = ({
  type,
  ...restProps
}: { type: any } & Record<string, any>) => {
  const { id: courseId } = useParams();

  const navigate = useNavigate();

  const handleExitPreviewClick = () => {
    if (courseId) {
      navigate(
        getCourseEditorPathByType({ courseType: type, courseId }),
      );
    }
  };

  return (
    <CoursePreviewLayout
      {...restProps}
      onExitPreviewClick={handleExitPreviewClick}
    />
  );
};

export default React.memo(CoursePreviewLayoutContainer) as any;
